import {
  U21AiChatBubbleType,
  U21AiChatRenderInnerProps,
} from 'app/shared/u21-ui/components/input/chat/shared';
import { U21AiChatButtonInner } from 'app/shared/u21-ui/components/input/chat/components/inner/U21AiChatButtonInner';
import { U21AiChatMultiSelectInner } from 'app/shared/u21-ui/components/input/chat/components/inner/U21AiChatMultiSelectInner';
import { U21AiChatSingleSelectInner } from 'app/shared/u21-ui/components/input/chat/components/inner/U21AiChatSingleSelectInner';

export const U21AiChatInner = ({
  type,
  choices,
  disabled,
  onSubmit,
  values,
}: U21AiChatRenderInnerProps) => {
  switch (type) {
    case U21AiChatBubbleType.BUTTON:
      return (
        <U21AiChatButtonInner
          choices={choices}
          disabled={disabled}
          onSubmit={onSubmit}
        />
      );
    case U21AiChatBubbleType.MULTISELECT:
      return (
        <U21AiChatMultiSelectInner
          choices={choices}
          disabled={disabled}
          initialValues={values}
          onSubmit={onSubmit}
        />
      );
    case U21AiChatBubbleType.SINGLESELECT:
      return (
        <U21AiChatSingleSelectInner
          choices={choices}
          disabled={disabled}
          initialValues={values}
          onSubmit={onSubmit}
        />
      );
    default:
      return null;
  }
};
